// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3J-j7","productName":"Table_productName__205aP"};